(() => {
  const SELECTOR = '[data-ergosia-reviews]';

  const makeVisualClone = (review) => {
    const clone = review.cloneNode(true);
    clone.classList.add('ergosia-review-clone');
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
    clone.querySelectorAll('[tabindex], a, button, input, select, textarea').forEach((node) => {
      node.setAttribute('tabindex', '-1');
    });
    return clone;
  };

  const makeGroup = (reviews, useOriginals = false) => {
    const group = document.createElement('div');
    group.className = 'ergosia-pdp-reviews__group';
    reviews.forEach((review) => group.appendChild(useOriginals ? review : makeVisualClone(review)));
    return group;
  };

  const makeRow = (reviews, direction, keepOriginals = false) => {
    const row = document.createElement('div');
    row.className = `ergosia-pdp-reviews__row ergosia-pdp-reviews__row--${direction}`;
    if (!keepOriginals) row.setAttribute('aria-hidden', 'true');

    const track = document.createElement('div');
    track.className = 'ergosia-pdp-reviews__track';
    track.appendChild(makeGroup(reviews, keepOriginals));
    track.appendChild(makeGroup(reviews));
    row.appendChild(track);
    return row;
  };

  const build = (section) => {
    if (section.dataset.reviewsMarqueeReady === 'true') return;

    const viewport = section.querySelector('.jdgm-rev-widg__reviews');
    if (!viewport) return;

    const pagination = section.querySelector('.jdgm-paginate');
    pagination?.style.setProperty('display', 'none', 'important');

    const reviews = Array.from(viewport.querySelectorAll(':scope > .jdgm-rev'));
    if (reviews.length < 2) {
      section.classList.add('is-single-review');
      return;
    }

    section.dataset.reviewsMarqueeReady = 'true';

    const rows = document.createElement('div');
    rows.className = 'ergosia-pdp-reviews__rows';
    rows.appendChild(makeRow(reviews, 'forward', true));

    const offset = Math.ceil(reviews.length / 2);
    const alternateOrder = reviews.slice(offset).concat(reviews.slice(0, offset));
    rows.appendChild(makeRow(alternateOrder, 'reverse'));
    viewport.appendChild(rows);
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((section) => build(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
